import { render, staticRenderFns } from "./pygame-template.vue?vue&type=template&id=c05bc402&scoped=true"
import script from "./pygame-template.vue?vue&type=script&lang=js"
export * from "./pygame-template.vue?vue&type=script&lang=js"
import style0 from "./pygame-template.vue?vue&type=style&index=0&id=c05bc402&scoped=true&lang=scss"
import style1 from "./pygame-template.vue?vue&type=style&index=1&id=c05bc402&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c05bc402",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c05bc402')) {
      api.createRecord('c05bc402', component.options)
    } else {
      api.reload('c05bc402', component.options)
    }
    module.hot.accept("./pygame-template.vue?vue&type=template&id=c05bc402&scoped=true", function () {
      api.rerender('c05bc402', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/research/curriculum-manage/components/pygame-template.vue"
export default component.exports